/* Tisha B2B quote popup — shared bind logic. Wires up:
   - <button data-tp-b2b-open aria-controls="POPUP_ID"> → opens corresponding modal
   - data-tp-b2b-close inside modal → closes
   - Escape key → closes any open modal
   - On render-with-success → auto-open modal + 12s countdown + auto-close + URL clean
*/
(function(){
  function openModal(modal){
    if(!modal) return;
    modal.classList.remove('is-hidden');
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('overflow-hidden');
    document.body.style.overflow='hidden';
    var firstInput = modal.querySelector('input:not([type="hidden"]),textarea');
    var success = modal.querySelector('[data-tp-b2b-success]');
    if(firstInput && !success){
      setTimeout(function(){ try{ firstInput.focus(); }catch(e){} }, 50);
    }
  }
  function closeModal(modal){
    if(!modal) return;
    modal.classList.add('is-hidden');
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('overflow-hidden');
    document.body.style.overflow='';
    /* Strip ?contact_posted=true so reload doesn't keep re-opening success state */
    try{
      if(window.location.search.indexOf('contact_posted') !== -1){
        history.replaceState(null,'',window.location.pathname);
      }
    }catch(e){}
  }
  function bindOpener(btn){
    var id = btn.getAttribute('aria-controls');
    if(!id) return;
    var modal = document.getElementById(id);
    if(!modal) return;
    btn.addEventListener('click', function(e){
      e.preventDefault();
      openModal(modal);
    });
  }
  function bindCloser(btn){
    var modal = btn.closest('[data-tp-b2b-modal]');
    btn.addEventListener('click', function(){ closeModal(modal); });
  }
  function bindEscape(){
    document.addEventListener('keydown', function(e){
      if(e.key !== 'Escape') return;
      var open = document.querySelector('[data-tp-b2b-modal]:not(.is-hidden)');
      if(open) closeModal(open);
    });
  }
  function initSuccessStates(){
    /* For each modal that rendered with success state — auto-open + countdown + close */
    var successes = document.querySelectorAll('[data-tp-b2b-success]');
    successes.forEach(function(success){
      var modal = success.closest('[data-tp-b2b-modal]');
      if(!modal) return;
      openModal(modal);
      var countdown = success.querySelector('[data-tp-b2b-countdown]');
      var seconds = 12;
      var timer = setInterval(function(){
        seconds -= 1;
        if(countdown) countdown.textContent = seconds;
        if(seconds <= 0){
          clearInterval(timer);
          closeModal(modal);
        }
      }, 1000);
    });
  }
  function init(){
    document.querySelectorAll('[data-tp-b2b-open]').forEach(bindOpener);
    document.querySelectorAll('[data-tp-b2b-modal] [data-tp-b2b-close]').forEach(bindCloser);
    bindEscape();
    initSuccessStates();
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
